import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/main',
    pathMatch: 'full'
  },
  {
    path: 'main',
    component: LayoutComponent,
    loadChildren: () => import('./pages/main/main.module').then(m => m.MainModule)
  },
  {
    path: 'approach',
    component: LayoutComponent,
    loadChildren: () => import('./pages/approach/approach.module').then(m => m.ApproachModule)
  },
  {
    path: 'tech',
    redirectTo: 'main',
    pathMatch: 'full'
  },
  {
    path: 'about',
    component: LayoutComponent,
    loadChildren: () => import('./pages/about/about.module').then(m => m.AboutModule)
  },
  {
    path: 'services',
    component: LayoutComponent,
    loadChildren: () => import('./pages/services/services.module').then(m => m.ServicesModule)
  },
  {
    path: 'core-services',
    redirectTo: 'services',
    pathMatch: 'full'
  },
  {
    path: 'expertise',
    redirectTo: 'approach',
    pathMatch: 'full'
  },
  {
    path: 'contact',
    component: LayoutComponent,
    loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    //useHash: true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
